'use client';

import { clsx as cx } from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import { Tooltip } from '@/components/tooltip';
import { joinSgcmMedia } from '@/utils/url/join/public';

import styles from '../styles.module.scss';
import {
  ICON_SIZE_IN_PIXEL,
  POINT_DESCRIPTION,
  REVIEWER_LINK,
  TEXTBOX_ICON_SRC,
} from './constant';
import type { Component } from './types';

export const AvatarBottomItems: Component = ({
  consumerReview,
}) => (
  <>
    <div className={
      styles.containerAvatarBottomItem
    }>
      <Image
        alt="textbox icon image"
        height={ICON_SIZE_IN_PIXEL}
        src={`${joinSgcmMedia(TEXTBOX_ICON_SRC)}`}
        width={ICON_SIZE_IN_PIXEL} />
      <Link
        className={styles.reviewerLink}
        href={`${REVIEWER_LINK}&id=${consumerReview.member?.id}`}
        target="_blank">
        {consumerReview.member?.postCount}
        {' '}
        reviews
      </Link>
    </div>
    <div className={
      styles.containerAvatarBottomItem
    }>
      <Image
        alt="stereoscopic icon image"
        height={ICON_SIZE_IN_PIXEL}
        src={`${joinSgcmMedia('/public/new-cars/icon/stereoscopicCoin.svg')}`}
        width={ICON_SIZE_IN_PIXEL} />
      <span>
        {consumerReview.member?.memberPoints}
        {' '}
        Points
      </span>
      <Tooltip
        className={cx(
          styles.containerTooltip,
          styles.containerGradeTooltip,
        )}
        content={(
          <div className={cx(
            styles.containerTooltipContent,
          )}>
            <div className={
              styles.containerRankToolTip
            }>
              {POINT_DESCRIPTION}
            </div>
          </div>
        )}>
        <button
          className={
            styles.buttonRecommendedPriceDesc
          }>
          <Image
            alt="info outline icon image"
            className={cx(
              styles.imageHoverIcon,
            )}
            height={ICON_SIZE_IN_PIXEL}
            src={`${joinSgcmMedia('/public/new-cars/icon/iconOutlineInfo.svg')}`}
            width={ICON_SIZE_IN_PIXEL} />
        </button>
      </Tooltip>
    </div>
  </>
);
